import { defineComponent as _defineComponent } from 'vue';
import Button from 'primevue/button';
import Sidebar from 'primevue/sidebar';
import StationDetails from './StationDetails.vue';
import LinkStation from './LinkStation.vue';
import { ref } from 'vue';
import { trans } from 'laravel-vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WeatherStationBadge',
    props: {
        weatherStation: {
            type: Object,
            required: true,
        },
    },
    setup(__props, { expose }) {
        expose();
        let visibleRight = ref(false);
        let visibleRightLinkStation = ref(false);
        const __returned__ = { get visibleRight() { return visibleRight; }, set visibleRight(v) { visibleRight = v; }, get visibleRightLinkStation() { return visibleRightLinkStation; }, set visibleRightLinkStation(v) { visibleRightLinkStation = v; }, get Button() { return Button; }, StationDetails, LinkStation, get trans() { return trans; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
